import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {CropFrameMode} from '../../../../common/enums/enums';
import {CropInfo} from '../../../../common/models/CropInfo';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'app-image-crop-component',
    templateUrl: './image-crop-component.component.html',
    styleUrls: ['./image-crop-component.component.scss'],
    inputs: ['imageUrlTest'],
    standalone: false
})
export class ImageCropComponentComponent implements OnInit {

  sqrWidthHeight: number = environment.CROP_SQURE_WIDTH;
  circleRadius: number = environment.CROP_SQURE_WIDTH / 2;
  frameWidth: number;
  frameHeight: number;
  imageWidth: number;
  imageHeight: number;
  zoomScale: number = 10;
  translateX: number = 0;
  translateY: number = 0;
  transformVal: string = 'translate(0 0)';
  imageObj = new Image();


  // The uploaded or cropped file.
  fileObject: any;
  selectedElement: any = false;

  initialCropX: number;
  initialCropY: number;

  // Cordinations for cropper area - squre
  cropperAreaX: number;
  cropperAreaY: number;
  cropperAreaW: number;
  cropperAreaH: number;

  // Cordinations for cropper area - circle
  circleCropperX: number;
  circleCropperY: number;

  // Cropped cordinations for actual image
  cropX: number;
  cropY: number;
  cropWidth: number;
  cropHeight: number;

  // DragImage
  draggingStarted: boolean = false;
  initialX: number;
  initialY: number;
  yOffset: any = 0;
  xOffset: any = 0;
  active: boolean = false;
  currentX: number;
  currentY: number;
  loadIntialCropping: boolean = false;
  isSqureCrop: boolean = false;
  public zoomValue: number = 100;
  preZoomValue: number = 100;
  maxZoomValue: number = 201;
  minZoomValue: number = 0;
  panelWidth: number;
  marignWidth: number = 50;
  popupStyle: string;

  @Input() imageUrl: any;
  @Input() cropFrameMode: CropFrameMode;
  @Input() isFullScreenPopUp: boolean;
  @Input() cropInfo: CropInfo;
  @Input() dropZoneInfo: any; // holdes the value of the drop zone (width and hight)
  @Input() popupWidth: string;
  @Output() fileCropInfo = new EventEmitter<CropInfo>();
  @Output() isfileCleared = new EventEmitter<boolean>();

  @ViewChild('canvas1') canvas1: ElementRef;
  @ViewChild('#zoomBar') zoomBar: ElementRef;

  finalrenderImageWidth: number;
  finalrenderImageHeight: number;

  constructor() { }

  ngOnInit(): void {
    this.panelWidth = Number(this.popupWidth.replace('%', ''));
    this.setPopupStyle(this.panelWidth);
    this.init();
  }

  setPopupStyle(panelWidth: number) {
    this.popupStyle = (panelWidth > this.marignWidth) ? "main" : "short";
  }

  init() {
    if (this.dropZoneInfo) {
      this.frameWidth = this.dropZoneInfo.width; // Drop zone width but NOT CHANGING
      this.frameHeight = this.dropZoneInfo.height; // Drop zone height but NOT CHANGING
      this.imageWidth = this.dropZoneInfo.width; // Drop zone width but CHANGES  by zooming level
      this.imageHeight = this.dropZoneInfo.height; // Drop zone height but CHANGES  by zooming level

      this.initialCropX = (this.dropZoneInfo.width - this.sqrWidthHeight) / 2;
      this.initialCropY = (this.dropZoneInfo.height - this.sqrWidthHeight) / 2;

      this.cropperAreaX = this.initialCropX;
      this.cropperAreaY = this.initialCropY;

      this.circleCropperX = this.cropperAreaX + this.circleRadius;
      this.circleCropperY = this.cropperAreaY + this.circleRadius;
    }
    this.loadIntialCropping = false;
    this.setCropFrame();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'imageUrl': {
            this.init();
          }
        }
      }
    }
  }

  ngAfterContentChecked(): void {
    this.recognizeCropCordinates();
  }

  //DragImage
  @HostListener('touchstart', ['$event'])
  @HostListener("mousedown", ["$event"])
  dragStart($event) {
    this.draggingStarted = $event.target.id === 'innerImg';
    if (this.draggingStarted) {
      let dragItem = document.querySelector("#ItemDrag");

      console.log("dragStart");

      if ($event.type === "touchstart") {
        this.initialX = $event.touches[0].clientX - this.yOffset;
        this.initialY = $event.touches[0].clientY - this.yOffset;
      } else {
        console.log('initial x setting ');
        this.initialX = $event.clientX - this.xOffset;
        this.initialY = $event.clientY - this.yOffset;
      }

      if ($event.target === dragItem) {
        this.active = true;
      }
    }
  }

  @HostListener('touchend', ['$event'])
  @HostListener("mouseup", ["$event"])
  dragEnd($event) {
    // console.log('mouse up');
    if (this.draggingStarted && $event.target.id === 'innerImg') {
      this.active = false;
      this.draggingStarted = false;
      this.recognizeCropCordinates();
    }
    this.draggingStarted = false;
  }


  @HostListener('touchmove', ['$event'])
  @HostListener("mousemove", ["$event"])
  drag($event) {
    // Review: Using id to find the #innerImg area is much better/ next => can determine without having classes.
    if (this.draggingStarted && $event.target.id === 'innerImg') // || (
    {

      if ($event.type === 'touchmove') {
        console.log('touch detected');
        this.currentX = $event.touches[0].clientX - this.yOffset;
        this.currentY = $event.touches[0].clientY - this.yOffset;
      } else {
        this.currentX = $event.clientX;
        this.currentY = $event.clientY;
      }

      let hdifference = this.currentX - this.initialX;
      this.initialX = this.currentX;
      console.log('initialX: ' + this.initialX);
      console.log('currentX: ' + this.currentX);
      console.log('hdifference: ' + hdifference);
      console.log('imageDifference: ' + (this.imageWidth - this.sqrWidthHeight));
      let vdifference = this.currentY - this.initialY;
      console.log('vdifference: ' + vdifference);

      if (((this.cropX > 0)
        || (this.cropX <= 0 && hdifference < 0))
        && (this.cropX < (this.imageObj.width - this.cropWidth)
          || this.cropX >= (this.imageObj.width - this.cropWidth) && hdifference > 0)
      ) {
        this.updateHorizontal(hdifference);
      }

      if ((this.cropperAreaY > 0 && (this.cropperAreaY < this.imageHeight - this.sqrWidthHeight))
        || (this.cropperAreaY > 0 && vdifference > 0)
        || (this.cropperAreaY < (this.imageHeight - this.sqrWidthHeight) && vdifference < 0)) {
        this.updateVertical(vdifference);
      }

      this.active = false;
    }
  }

  startDrag(evt) {
    if (evt.target.classList.contains('draggable')) {
      this.selectedElement = evt.target;
    }
  }

  removeBtnClick() {
    this.isfileCleared.emit(true);
  }

  endDrag(evt) {
    this.selectedElement = null;
  }

  zoomIn(changeZoomLevel: boolean) {
    if (this.zoomValue <= this.maxZoomValue) {
      this.translateX = this.translateX - (this.zoomScale / 2);
      this.translateY = this.translateY - (this.zoomScale / 2);
      this.cropperAreaX = (this.cropperAreaX + (this.zoomScale / 2));
      this.cropperAreaY = this.cropperAreaY + (this.zoomScale / 2);
      this.circleCropperX = this.circleCropperX + (this.zoomScale / 2);
      this.circleCropperY = this.circleCropperY + (this.zoomScale / 2);
      this.transformVal = 'translate(' + this.translateX + ' ' + this.translateY + ')';
      this.imageWidth = this.imageWidth + this.zoomScale;
      this.imageHeight = this.imageHeight + this.zoomScale;
      if (changeZoomLevel)
        this.zoomValue = this.zoomValue + (this.zoomScale / 2);
      this.recognizeCropCordinates();
    }
  }

  zoomOut(changeZoomLevel: boolean) {
    if (((this.cropX > 0))
      && (this.cropX < (this.imageObj.width - this.cropWidth))
      && ((this.cropY > 0))
      && (this.cropY < (this.imageObj.height - this.cropHeight))) {
      if (this.zoomValue > this.minZoomValue) {
        this.translateX = this.translateX + (this.zoomScale / 2);
        this.translateY = this.translateY + (this.zoomScale / 2);
        this.imageWidth = this.imageWidth - this.zoomScale;
        this.imageHeight = this.imageHeight - this.zoomScale;
        this.cropperAreaX = (this.cropperAreaX - (this.zoomScale / 2));
        this.cropperAreaY = this.cropperAreaY - (this.zoomScale / 2);
        this.circleCropperX = this.circleCropperX - (this.zoomScale / 2);
        this.circleCropperY = this.circleCropperY - (this.zoomScale / 2);
        this.transformVal = 'translate(' + this.translateX + ' ' + this.translateY + ')';
        if (changeZoomLevel)
          this.zoomValue = this.zoomValue - (this.zoomScale / 2);
        this.recognizeCropCordinates();
      }
    }
  }

  zoomBySlider(value) {
    console.log("zoom value : " + value);
    console.log("pre zoom value : " + this.preZoomValue);

    let difference = 0;
    if (this.preZoomValue < value) {
      console.log("zooming");
      difference = value - this.preZoomValue;
      let differenceInTimesOfFive = Math.floor((difference / 5));
      this.preZoomValue = this.preZoomValue + (differenceInTimesOfFive * 5);
      for (let i = 0; i < differenceInTimesOfFive; i++) {
        this.zoomIn(false);
      }
    }
    else {
      console.log("zoomout");
      difference = this.preZoomValue - value;
      let differenceInTimesOfFive = Math.floor((difference / 5));
      this.preZoomValue = this.preZoomValue - (differenceInTimesOfFive * 5);
      for (let i = 0; i < differenceInTimesOfFive; i++) {
        this.zoomOut(false);
      }
    }
  }

  updateHorizontal(difference) {
    this.translateX = this.translateX + (difference);
    this.cropperAreaX = this.cropperAreaX - (difference);
    this.circleCropperX = this.circleCropperX - (difference);
    this.transformVal = 'translate(' + this.translateX + ' ' + this.translateY + ')';
  }

  updateVertical(difference) {
    this.translateY = this.translateY + (difference / 20);
    this.cropperAreaY = this.cropperAreaY - (difference / 20);
    this.circleCropperY = this.circleCropperY - (difference / 20);
    this.transformVal = 'translate(' + this.translateX + ' ' + this.translateY + ')';
  }

  recognizeCropCordinates() {
    this.loadIntialCropping = true;
    this.imageObj = new Image();
    this.imageObj.src = this.imageUrl

    this.imageObj.onload = () => {
      let width = this.imageObj.width;
      let height = this.imageObj.height;

      let xratio = width / this.imageWidth;
      let yratio = height / this.imageHeight;
      let originalXRatio = width / this.dropZoneInfo.width;

      let renderImageHeight = (height / originalXRatio);
      // let renderImageWidth = (width / yratio);

      let touchesVertically = renderImageHeight >= this.dropZoneInfo.height;
      let imageHeightDifferentRatio = (this.imageHeight - this.frameHeight) !== 0 ? ((this.frameHeight) / this.imageHeight) : 1;

      if (touchesVertically) {
        this.finalrenderImageWidth = (width / yratio);
        this.finalrenderImageHeight = this.frameHeight;
        this.cropHeight = ((height / this.finalrenderImageHeight) * this.sqrWidthHeight) * imageHeightDifferentRatio;
        this.cropWidth = this.cropHeight;
      }
      else {
        this.finalrenderImageHeight = (height / xratio);
        this.finalrenderImageWidth = this.frameWidth;
        this.cropWidth = ((width / this.finalrenderImageWidth) * this.sqrWidthHeight) * imageHeightDifferentRatio;
        this.cropHeight = this.cropWidth;
      }

      let gap = this.imageWidth - this.finalrenderImageWidth;
      this.cropX = (this.cropperAreaX - (gap / 2)) / this.finalrenderImageWidth * width;

      this.cropY = this.cropperAreaY / this.imageHeight * height;

      this.updateCropInfo();
    };
  }

  // update and emit current crop info to parent
  updateCropInfo() {
    this.cropInfo = {
      X: this.cropX,
      Y: this.cropY,
      Width: this.cropWidth,
      Height: this.cropHeight
    } as CropInfo;

    this.fileCropInfo.emit(this.cropInfo);
  }

  // set cropper mode cricle/squre
  setCropFrame() {
    if (this.cropFrameMode == 0) {
      this.isSqureCrop = false;
    }
    else {
      this.isSqureCrop = true;
    }
  }

  toString(): string {
    return ('X: ' + this.cropX + ' Y: ' + this.cropY + ' W: ' + this.cropWidth + ' H: ' + this.cropWidth) as string;
  }
}
